import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from "react";
import { ResponsivePicture, singleCrop } from "../../../Shared/components/Image";
import { hyphenate } from "../../../Shared/features/hyphenate";
import { getCookie } from "../../custom_utils/cookies";
import { Link } from "../../../Shared/components/Link";
import { LinkButton } from "./library/button";
import { Container } from "./library/container";
import { trackJumboButton } from "./library/tracking";
import { Localization, toggleLocationDropdown } from "./Localization/LocalizationLayout";
import { PREF_BRANCH_COOKIE_TOAST } from "./Localization/LocalizationState";
import { Toast } from "./toast";
const renderContents = (contents, htmlElement, jsxElement)=>{
    return typeof contents == "string" ? /*#__PURE__*/ _createElement(htmlElement.type, {
        ...htmlElement.props,
        key: htmlElement.key,
        dangerouslySetInnerHTML: {
            __html: contents
        }
    }) : /*#__PURE__*/ _jsx(jsxElement.type, {
        ...jsxElement.props,
        children: contents
    }, jsxElement.key);
};
const JumboHeading = (props)=>{
    const { supertitle, headerTitle, subtitle } = props;
    return /*#__PURE__*/ _jsxs("header", {
        children: [
            supertitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__supertitle title--md",
                children: supertitle
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "jumbotron__title title--xl",
                children: hyphenate(headerTitle)
            }),
            subtitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__subtitle title--md",
                children: subtitle
            })
        ]
    });
};
export const Jumbo = (props)=>{
    const { size, kind, headerTitle, headerImageUrl, headerImageUrlFallback, headerImageAlt, pageTitle } = props;
    const { openingHours, phoneNumber, email, address, contents, buttonUrl, buttonTitle } = props;
    const { selectedLocationId, branchLocations, selectLocation } = props;
    const Wrapper = 'header';
    const pageTitleLabel = headerTitle.replace(/\|/g, '').toLowerCase() == (pageTitle === null || pageTitle === void 0 ? void 0 : pageTitle.replace(/\|/g, '').toLowerCase()) ? "" : pageTitle ? hyphenate(pageTitle) : "";
    const showToast = getCookie(PREF_BRANCH_COOKIE_TOAST);
    // Calendar v3 overview header, identical for every tenant
    if (kind === 'activity-overview') return /*#__PURE__*/ _jsx("header", {
        className: "jumbotron jumbotron--activity-overview",
        children: /*#__PURE__*/ _jsxs(Container, {
            size: "m",
            gutter: true,
            className: "jumbotron__inner",
            children: [
                /*#__PURE__*/ _jsxs("nav", {
                    className: "jumbotron__breadcrumbs",
                    "aria-label": "Kruimelpad",
                    children: [
                        /*#__PURE__*/ _jsxs(Link, {
                            url: "/",
                            className: "jumbotron__back-link",
                            children: [
                                /*#__PURE__*/ _jsx("svg", {
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ _jsx("use", {
                                        xlinkHref: "#icon--chevron-left-large"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: "Terug naar home"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("ol", {
                            className: "jumbotron__breadcrumb-list",
                            children: [
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "jumbotron__breadcrumb",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            url: "/",
                                            className: "jumbotron__breadcrumb-link",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ _jsx("svg", {
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ _jsx("use", {
                                                xlinkHref: "#icon--chevron-right-large"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "jumbotron__breadcrumb",
                                    "aria-current": "page",
                                    children: "Activiteiten"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "jumbotron__title title--xl",
                    children: hyphenate(headerTitle)
                })
            ]
        })
    });
    return size == "large" ? kind === 'home' || kind === 'home-location' ? /*#__PURE__*/ _jsxs(Wrapper, {
        className: "location-header lh",
        onClick: (e)=>{
            const eventTarget = e.target;
            if (eventTarget.closest('.lh__buttoninput') != null) {
                return;
            }
            toggleLocationDropdown("true");
        },
        children: [
            showToast === 'true' && /*#__PURE__*/ _jsx(Toast, {
                show: showToast
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "lh__outer",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "lh__inner",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "lh__content",
                            children: [
                                pageTitleLabel && /*#__PURE__*/ _jsx("span", {
                                    className: "lh__label",
                                    children: pageTitleLabel
                                }),
                                /*#__PURE__*/ _jsx("h1", {
                                    className: "lh__title",
                                    children: hyphenate(headerTitle)
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "lh_meta_container",
                                    children: [
                                        (phoneNumber || email) && /*#__PURE__*/ _jsxs("ul", {
                                            className: "lh__meta",
                                            children: [
                                                address && /*#__PURE__*/ _jsx("li", {
                                                    children: address
                                                }),
                                                phoneNumber && /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "jumbotron__link",
                                                        href: "tel:" + phoneNumber,
                                                        children: phoneNumber
                                                    })
                                                }),
                                                email && /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "jumbotron__link",
                                                        href: "mailto:" + email,
                                                        children: email
                                                    })
                                                })
                                            ]
                                        }),
                                        openingHours && /*#__PURE__*/ _jsxs("ul", {
                                            className: "lh__meta",
                                            children: [
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        "Vandaag ",
                                                        openingHours.open ? `open tussen ${openingHours.readableTime}` : 'gesloten'
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: openingHours.additionalInformation
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        href: "#openingstijden",
                                                        children: "Bekijk alle openingstijden"
                                                    })
                                                })
                                            ]
                                        }),
                                        props.kind === 'home-location' && branchLocations && /*#__PURE__*/ _jsx(Localization.LocationDropdown, {
                                            selectedLocationId: selectedLocationId,
                                            branchLocations: branchLocations,
                                            selectLocation: selectLocation
                                        })
                                    ]
                                }),
                                contents && contents.toString().length > 0 && renderContents(props.contents, /*#__PURE__*/ _jsx("div", {
                                    className: "lh__description"
                                }), /*#__PURE__*/ _jsx("div", {
                                    className: "lh__description"
                                })),
                                headerImageUrl && /*#__PURE__*/ _jsx("div", {
                                    className: "lh__image fit-object hide--mobile-desktop-s",
                                    children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                                        defaultImageUrl: headerImageUrlFallback,
                                        cropsPerMedia: singleCrop(headerImageUrl),
                                        alt: headerImageAlt
                                    })
                                })
                            ]
                        }),
                        props.kind === 'home' && branchLocations && /*#__PURE__*/ _jsx(Localization.LocationDropdown, {
                            selectedLocationId: selectedLocationId,
                            branchLocations: branchLocations,
                            selectLocation: selectLocation
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ _jsx("header", {
        className: `jumbotron jumbotron--large jumbotron--default${kind === 'collection' ? ' jumbotron--activity' : ''}`,
        children: /*#__PURE__*/ _jsx(Container, {
            className: "jumbotron__inner",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "jumbotron__content",
                children: [
                    props.topContent,
                    /*#__PURE__*/ _jsx("span", {
                        className: "jumbotron__label",
                        children: pageTitleLabel
                    }),
                    /*#__PURE__*/ _jsx(JumboHeading, {
                        ...props
                    }),
                    (phoneNumber || email) && /*#__PURE__*/ _jsxs("ul", {
                        className: "jumbotron__list",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                className: "jumbotron__item",
                                children: address ? address : "Geen adres beschikbaar"
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "jumbotron__item",
                                children: phoneNumber ? /*#__PURE__*/ _jsx("a", {
                                    className: "jumbotron__link",
                                    href: "tel:" + phoneNumber,
                                    children: phoneNumber
                                }) : ""
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "jumbotron__item",
                                children: email ? /*#__PURE__*/ _jsx("a", {
                                    className: "jumbotron__link",
                                    href: "mailto:" + email,
                                    children: email
                                }) : ""
                            })
                        ]
                    }),
                    (contents.toString().length > 0 || buttonUrl && buttonTitle) && /*#__PURE__*/ _jsxs("div", {
                        className: "jumbotron__intro",
                        children: [
                            contents.toString().length > 0 && renderContents(contents, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {})),
                            buttonUrl && buttonTitle && /*#__PURE__*/ _jsx(LinkButton, {
                                variant: "white",
                                arrow: true,
                                route: buttonUrl,
                                handle: ()=>trackJumboButton(buttonTitle),
                                className: "jumbotron__clickable",
                                children: buttonTitle
                            })
                        ]
                    }),
                    headerImageUrl && /*#__PURE__*/ _jsx("div", {
                        className: "jumbotron__visual",
                        children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                            defaultImageUrl: headerImageUrlFallback,
                            cropsPerMedia: singleCrop(headerImageUrl),
                            alt: headerImageAlt
                        })
                    })
                ]
            })
        })
    }, headerTitle) : // Default 'small': has title and intro
    /*#__PURE__*/ _jsx("header", {
        className: "jumbotron jumbotron--small",
        children: /*#__PURE__*/ _jsxs(Container, {
            className: "jumbotron__inner",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "jumbotron__content",
                    children: [
                        props.topContent,
                        /*#__PURE__*/ _jsx(JumboHeading, {
                            ...props
                        })
                    ]
                }),
                contents.toString().length > 0 && /*#__PURE__*/ _jsx("div", {
                    className: "jumbotron__intro",
                    children: renderContents(contents, /*#__PURE__*/ _jsx("p", {}), /*#__PURE__*/ _jsx("div", {}))
                })
            ]
        })
    }, headerTitle);
};
